import type { ZoneItem } from "../response/store.response";
import type { BundleSaleItem } from "../bundle-sale.dto";

export type QUOTATION_CATEGORY_TYPE = "ALL" | "SUBMITTED" | "UNSUBMITTED";
export type PERIOD_TYPE = "M_PLUS_N" | "MONTH" | "DAY";

export interface getQuotationListForm {
  page: number;
  size: number;
  category: QUOTATION_CATEGORY_TYPE;
  search?: string;
}

export const initQuotationForm = {
  storeId: 0,
  storeName: "",
  targetDate: "",
  skNormalFee: undefined,
  isDpSelling: false,
  skNormalIsMonth: false,
  skNormalPeriod: undefined,
  ktNormalFee: undefined,
  ktNormalIsMonth: false,
  ktNormalPeriod: undefined,
  lgNormalFee: undefined,
  lgNormalIsMonth: false,
  lgNormalPeriod: undefined,
  isKidsAdditionalServiceUse: false,
  normals: [],
  lows: [],
  kids: [],
  dps: [],
  additionalServices: [],
  usims: [],
  etc: undefined,
  event: undefined,
  createAt: "",
};

export const newInitQuotationForm = {
  quotationId: 0,
  storeId: 0,
  isActive: true,
  isOnline: false,
  startDate: "",
  endDate: "",
  storeAreaName: "",
  mainZone: {
    zoneId: 0,
    region: "",
    zoneName: "",
  },
  subZones: [],
  storeName: "",
  isDpSelling: false,
  zoneId: 0,
  targetDate: "",
  version: 0,
  isMainFedActive: true,
  isLowFedActive: true,
  isKidsFedActive: true,
  skNormalFedFee: null,
  skNormalFedPeriodType: "M_PLUS_N" as PERIOD_TYPE,
  skNormalFedUsePeriod: null,
  ktNormalFedFee: null,
  ktNormalFedPeriodType: "M_PLUS_N" as PERIOD_TYPE,
  ktNormalFedUsePeriod: null,
  lgNormalFedFee: null,
  lgNormalFedPeriodType: "M_PLUS_N" as PERIOD_TYPE,
  lgNormalFedUsePeriod: null,
  skNormalPhdFee: null,
  skNormalPhdPeriodType: "M_PLUS_N" as PERIOD_TYPE,
  skNormalPhdUsePeriod: null,
  ktNormalPhdFee: null,
  ktNormalPhdPeriodType: "M_PLUS_N" as PERIOD_TYPE,
  ktNormalPhdUsePeriod: null,
  lgNormalPhdFee: null,
  lgNormalPhdPeriodType: "M_PLUS_N" as PERIOD_TYPE,
  lgNormalPhdUsePeriod: null,
  isKidsAdditionalServiceUse: false,
  createAt: "",
  publisherName: "",
  etc: "",
  event: "",
  normals: [],
  lows: [],
  kids: [],
  dps: [],
  additionalServices: [],
  usims: [],
}

export interface newQuotationForm {
  quotationId: number;
  /** 지점 정지 상태 (응답 전용) */
  isBanned?: boolean;
  banFrom?: string | null;
  banTo?: string | null;
  storeId: number | string;
  isActive: boolean;
  startDate: string;
  endDate: string;
  storeAreaName: string;
  storeName: string;
  isOnline: boolean;
  isDpSelling: boolean;
  zoneId: number;
  targetDate: string;
  mainZone: ZoneItem;
  subZones: ZoneItem[];
  version: number;
  isMainFedActive: boolean | null;
  isLowFedActive: boolean | null;
  isKidsFedActive: boolean | null;
  skNormalFedFee: number | null;
  skNormalFedPeriodType: PERIOD_TYPE | null;
  skNormalFedUsePeriod: number | null;
  ktNormalFedFee: number | null;
  ktNormalFedPeriodType: PERIOD_TYPE | null;
  ktNormalFedUsePeriod: number | null;
  lgNormalFedFee: number | null;
  lgNormalFedPeriodType: PERIOD_TYPE | null;
  lgNormalFedUsePeriod: number | null;
  skNormalPhdFee: number | null;
  skNormalPhdPeriodType: PERIOD_TYPE | null;
  skNormalPhdUsePeriod: number | null;
  ktNormalPhdFee: number | null;
  ktNormalPhdPeriodType: PERIOD_TYPE | null;
  ktNormalPhdUsePeriod: number | null;
  lgNormalPhdFee: number | null;
  lgNormalPhdPeriodType: PERIOD_TYPE | null;
  lgNormalPhdUsePeriod: number | null;
  isKidsAdditionalServiceUse: boolean;
  createAt: string;
  publisherName: string;
  etc: string;
  event: string;
  normals?: Array<newNormalQuotationObject>;
  lows?: Array<newLowsQuotationObject>;
  kids?: Array<newKidsQuotationObject>;
  dps?: Array<dpsQuotationObject>;
  additionalServices?: Array<additionalQuotationObject>;
  usims?: Array<usimQuotationObject>;
  /** 동시판매 추가 할인금 — 내부 키. 서버 필드명은 BUNDLE_SALE_API.formKey (bundle-sale.dto.ts) */
  bundleSales?: Array<BundleSaleItem>;
}

export interface quotationForm {
  storeId: number | string;
  storeName: string;
  targetDate: string;
  skNormalFee: number | undefined;
  skNormalIsMonth: boolean;
  isDpSelling?: boolean;
  skNormalPeriod: number | undefined;
  ktNormalFee: number | undefined;
  ktNormalIsMonth: boolean;
  ktNormalPeriod: number | undefined;
  lgNormalFee: number | undefined;
  lgNormalIsMonth: boolean;
  lgNormalPeriod: number | undefined;
  isKidsAdditionalServiceUse: boolean;
  normals?: Array<normalQuotationObject>;
  lows?: Array<lowsQuotationObject>;
  kids?: Array<kidsQuotationObject>;
  dps?: Array<dpsQuotationObject>;
  additionalServices: Array<additionalQuotationObject>;
  usims?: Array<usimQuotationObject>;
  etc: string | undefined;
  event: string | undefined;
  createAt: string;
}

export interface QuotationCopyForm {
  category: string;
  ownerId: string;
}

export interface ColorAndImage {
  color: string;
  imageId: number;
}

export interface normalQuotationObject {
  deviceId: number;
  deviceCode: string;
  deviceName: string;
  storage: string;
  skNcPrice: number | undefined;
  skCdPrice: number | undefined;
  ktNcPrice: number | undefined;
  ktCdPrice: number | undefined;
  lgNcPrice: number | undefined;
  lgCdPrice: number | undefined;
  type?: "ADD" | "REMAIN" | "CHECK";
}

export interface newNormalQuotationObject {
  deviceId: number;
  order: number | null;
  deviceCode: string | null;
  deviceName: string;
  storage: string;
  skNcPhdPrice: number | null;
  skCdPhdPrice: number | null;
  ktNcPhdPrice: number | null;
  ktCdPhdPrice: number | null;
  lgNcPhdPrice: number | null;
  lgCdPhdPrice: number | null;
  skNcFedPrice: number | null;
  skCdFedPrice: number | null;
  ktNcFedPrice: number | null;
  ktCdFedPrice: number | null;
  lgNcFedPrice: number | null;
  lgCdFedPrice: number | null;
  type?: "ADD" | "REMAIN" | "CHECK";
}

export interface lowsQuotationObject {
  uuid?: string;
  order: number;
  deviceId: number;
  deviceCode: string;
  deviceName: string;
  telecom: string;
  storage: string;
  fee: number;
  ncPrice: number;
  cdPrice: number;
  isMonth: boolean;
  period: number;
  type?: "ADD" | "REMAIN" | "CHECK";
}

export interface newLowsQuotationObject {
  uuid?: string;
  deviceId: number;
  deviceCode: string | null;
  deviceName: string;
  storage: string;
  telecom: string;
  fedFee: number | null;
  phdFee: number | null;
  ncPhdPrice: number | null;
  ncFedPrice: number | null;
  cdPhdPrice: number | null;
  cdFedPrice: number | null;
  phdUsePeriod: number | null;
  fedUsePeriod: number | null;
  phdPeriodType: PERIOD_TYPE | null;
  fedPeriodType: PERIOD_TYPE | null;
  type?: "ADD" | "REMAIN" | "CHECK";
}

export interface kidsQuotationObject {
  uuid?: string;
  cdPrice: number;
  deviceCode: string;
  deviceId: number;
  deviceName: string;
  storage?: string;
  fee: number;
  isMonth: boolean;
  ncPrice: number;
  naPrice: number;
  order: number;
  period: number;
  telecom: string;
  type?: "ADD" | "REMAIN" | "CHECK";
}

export interface newKidsQuotationObject {
  uuid?: string;
  deviceId: number;
  deviceCode: string | null;
  deviceName: string;
  storage: string;
  telecom: string;
  fedFee: number | null;
  phdFee: number | null;
  ncPhdPrice: number | null;
  cdPhdPrice: number | null;
  naPhdPrice: number | null;
  ncFedPrice: number | null;
  cdFedPrice: number | null;
  naFedPrice: number | null;
  fedPeriodType: PERIOD_TYPE | null;
  phdPeriodType: PERIOD_TYPE | null;
  phdUsePeriod: number | null;
  fedUsePeriod: number | null;
  type?: "ADD" | "REMAIN" | "CHECK";
}

export interface dpsQuotationObject {
  uuid?: string;
  elementId: number;
  deviceId: number;
  deviceCode: string;
  deviceName: string;
  color: string;
  storage: string;
  telecom: string;
  fee: number;
  ncPrice: number;
  cdPrice: number;
  sortOrder: number | null;
  order: number | null;
  isMonth: boolean;
  periodType: PERIOD_TYPE | null;
  isActive: boolean;
  usePeriod: number;
  type?: "ADD" | "REMAIN" | "CHECK";
}

export interface additionalQuotationObject {
  serviceId: number;
  telecom: string;
  serviceName: string;
  isMonth: boolean;
  periodType: PERIOD_TYPE | null;
  usePeriod: number | null;
  duration: number | undefined;
  isVariable: boolean;
  serviceFee: number | undefined;
  isMandatory: boolean;
  nonSubscriptionFee: number | undefined;
}

export interface usimQuotationObject {
  elementId: number;
  telecom: string;
  fee: number;
  price: number;
  sortOrder: number;
  isMonth: boolean;
  periodType: PERIOD_TYPE | null;
  usePeriod: number;
  type?: "ADD" | "REMAIN" | "CHECK";
}

export interface dpsActiveObject {
  elementId: number;
  isActive: boolean;
}

export interface quotationCopyTarget {
  storeToId: number;
  /** 대상 지점에 부가서비스까지 복사할지 여부 */
  copyService: boolean;
}

export interface quotationCopyForm {
  storeFromId: string;
  storeCopyTo: quotationCopyTarget[];
  date: string;
  mainEditValue?: string;
  lowEditValue?: string;
  kidsEditValue?: string;
}